import React from 'react';
import {
  Box,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';

export default function AlgorithmSteps({ steps = [] }) {
  if (!steps.length) return null;

  const sorted = [...steps].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        Step-by-step algorithm
      </Typography>
      <Stepper orientation="vertical" nonLinear>
        {sorted.map((step) => (
          <Step key={step.order ?? step.title} active expanded>
            <StepLabel>{step.title}</StepLabel>
            <StepContent>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {step.explanation}
              </Typography>
              {step.api && (
                <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace' }}>
                  API: {step.api}
                </Typography>
              )}
              {step.frontendPath && (
                <Typography variant="caption" sx={{ display: 'block', color: '#6366f1' }}>
                  Frontend: {step.frontendPath}
                </Typography>
              )}
              {step.backendFile && (
                <Typography variant="caption" sx={{ display: 'block', color: '#64748b' }}>
                  Backend: {step.backendFile}
                </Typography>
              )}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
